import { render, staticRenderFns } from "./log-ledger.vue?vue&type=template&id=6cc290fa&scoped=true&"
import script from "./log-ledger.vue?vue&type=script&lang=js&"
export * from "./log-ledger.vue?vue&type=script&lang=js&"
import style0 from "./log-ledger.vue?vue&type=style&index=0&id=6cc290fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc290fa",
  null
  
)

export default component.exports